/*
 * Prime Phones — Google reviews section (sections/pp-google-reviews.liquid).
 *
 * The reviews come from the Google reviews app's public data, fetched only
 * when a section is about to scroll into view and kept for 6 hours (one
 * fetch for every section on the page). The row is filled in place: the
 * blank cards already hold its size, so nothing moves.
 *
 * Also: arrows and mouse drag (computers), native swipe (phones), "Read
 * more" and photo taps open the whole review in a <dialog> with the photos
 * one at a time, and an optional gentle autoplay that stops for good once
 * someone uses the row.
 */
(function () {
  if (window.__ppReviews) return;
  window.__ppReviews = true;

  var KEY = 'pp-google-reviews-all';
  var MAX_AGE = 6 * 60 * 60 * 1000;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var loading = null;

  /* ---------- data ---------- */
  function slim(b) {
    return {
      r: Number(b.rating) || 0,
      n: Number(b.reviewsNumber) || 0,
      url: b.url || '',
      write: b.writeReviewUrl || '',
      t: Date.now(),
      list: (b.reviews || []).filter(function (x) { return !x.hide; }).map(function (x) {
        return {
          a: x.authorName || '',
          p: x.profilePhotoUrl || '',
          s: Number(x.rating) || 0,
          x: x.text || '',
          w: Number(x.time) || 0,
          i: (x.images || []).map(function (im) { return im.url || im.thumbnailUrl; }).filter(Boolean)
        };
      })
    };
  }

  function load(shop) {
    if (loading) return loading;
    var hit = null;
    try { hit = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { hit = null; }
    if (hit && hit.list && Date.now() - hit.t < MAX_AGE) return (loading = Promise.resolve(hit));
    loading = fetch('https://grw.reputon.com/app/storefront/widget?shop=' + encodeURIComponent(shop) + '&lang=en')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (j) {
        var b = j && j.business && j.business[0];
        if (!b || !b.rating) return hit || null;
        var v = slim(b);
        try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
        return v;
      })
      .catch(function () { return hit || null; });
    return loading;
  }

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* Google photo addresses take a size: ask for what is shown. */
  function sized(url, spec) {
    if (!/googleusercontent\.com/.test(url)) return url;
    if (/=k-no$/.test(url)) return url.replace(/=k-no$/, '=' + spec + '-k-no');
    if (/=s\d+/.test(url)) return url;
    return url;
  }

  var rtf = window.Intl && Intl.RelativeTimeFormat ? new Intl.RelativeTimeFormat('en', { numeric: 'auto' }) : null;
  function ago(sec) {
    if (!sec || !rtf) return '';
    var days = Math.round((Date.now() / 1000 - sec) / 86400);
    if (days < 1) return rtf.format(0, 'day');
    if (days < 7) return rtf.format(-days, 'day');
    if (days < 30) return rtf.format(-Math.round(days / 7), 'week');
    if (days < 365) return rtf.format(-Math.max(1, Math.round(days / 30)), 'month');
    return rtf.format(-Math.round(days / 365), 'year');
  }

  var TINTS = ['#0a7d8e', '#0a5ceb', '#7c3aed', '#be185d', '#b45309', '#15803d'];
  function avatar(r) {
    if (r.p) {
      var img = el('img', 'ppgr__av');
      img.src = r.p;
      img.alt = '';
      img.width = 36;
      img.height = 36;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      return img;
    }
    var span = el('span', 'ppgr__av ppgr__av--letter', (r.a.trim()[0] || '?').toUpperCase());
    span.style.background = TINTS[r.a.length % TINTS.length];
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  function stars(n, tpl) {
    var wrap = el('span', 'ppgr__stars');
    wrap.style.setProperty('--ppgr-r', (Math.max(0, Math.min(5, n)) / 5 * 100) + '%');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', String(tpl || '[n] out of 5 stars').replace('[n]', n));
    wrap.innerHTML = '<svg viewBox="0 0 70 13" aria-hidden="true" focusable="false"><use href="#ppgr-starrow"/></svg>' +
      '<svg viewBox="0 0 70 13" class="ppgr__stars-fill" aria-hidden="true" focusable="false"><use href="#ppgr-starrow"/></svg>';
    return wrap;
  }

  var G = '<svg class="ppgr__g" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>';

  function top(r, url) {
    var row = el('div', 'ppgr__top');
    row.appendChild(avatar(r));
    var who = el('div', 'ppgr__who');
    var name = el(url ? 'a' : 'span', 'ppgr__name', r.a);
    if (url) {
      name.href = url;
      name.target = '_blank';
      name.rel = 'noopener';
    }
    who.appendChild(name);
    var when = ago(r.w);
    if (when) who.appendChild(el('span', 'ppgr__when', when));
    row.appendChild(who);
    row.insertAdjacentHTML('beforeend', G);
    return row;
  }

  /* ---------- one section ---------- */
  function Section(root) {
    this.root = root;
    this.track = root.querySelector('[data-ppgr-track]');
    this.rail = root.querySelector('[data-ppgr-rail]');
    this.arrows = root.querySelector('[data-ppgr-arrows]');
    this.dlg = root.querySelector('[data-ppgr-dlg]');
    this.body = root.querySelector('[data-ppgr-dlg-body]');
    this.d = root.dataset;
    this.items = [];
    this.userMoved = false;
    var self = this;

    /* The data (about 28 KB) is fetched at the first quiet moment, so the
       cards are filled before anyone scrolls down to them; their pictures
       still load only when they come into view. Scrolling close first
       starts it straight away. */
    var go = function () {
      if (self.started) return;
      self.started = true;
      self.start();
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 3000 });
    else setTimeout(go, 1500);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        go();
      }, { rootMargin: '1200px 0px' });
      io.observe(root);
    }
  }

  Section.prototype.start = function () {
    var self = this;
    load(this.d.shop).then(function (v) { self.fill(v); });
  };

  Section.prototype.pick = function (v) {
    var min = Number(this.d.minStars) || 1;
    var textOnly = this.d.textOnly === 'true';
    var hide = String(this.d.hide || '').split('|').map(function (n) { return n.trim().toLowerCase(); }).filter(Boolean);
    var list = v.list.filter(function (r) {
      return r.s >= min && (!textOnly || r.x.trim()) && hide.indexOf(r.a.trim().toLowerCase()) === -1;
    });
    list.sort(function (a, b) { return b.w - a.w; });
    if (this.d.sort === 'photos') {
      list.sort(function (a, b) { return (b.i.length ? 1 : 0) - (a.i.length ? 1 : 0) || b.w - a.w; });
    }
    /* "Show these reviews first", in the order given; the rest keep their order. */
    var first = String(this.d.first || '').split('|').map(function (n) { return n.trim().toLowerCase(); }).filter(Boolean);
    if (first.length) {
      var rank = function (r) { var k = first.indexOf(r.a.trim().toLowerCase()); return k === -1 ? first.length : k; };
      list = list.map(function (r, k) { return { r: r, k: k }; })
        .sort(function (a, b) { return rank(a.r) - rank(b.r) || a.k - b.k; })
        .map(function (x) { return x.r; });
    }
    return list.slice(0, Number(this.d.max) || 12);
  };

  Section.prototype.fill = function (v) {
    var root = this.root;
    this.track.removeAttribute('aria-busy');
    if (!v) {
      /* No data at all: keep the rating line and buttons, leave the row out. */
      this.track.hidden = true;
      return;
    }
    /* Live rating, count and links. */
    var val = root.querySelector('[data-ppgr-value]');
    if (val && v.r) val.textContent = (Math.round(v.r * 10) / 10).toFixed(1);
    var st = root.querySelector('[data-ppgr-stars]');
    if (st && v.r) st.style.setProperty('--ppgr-r', (v.r / 5 * 100) + '%');
    var cnt = root.querySelector('[data-ppgr-count]');
    if (cnt && v.n) cnt.textContent = String(this.d.sumTpl).replace('[n]', v.n);
    var sum = root.querySelector('[data-ppgr-sum]');
    if (sum && v.url && !sum.getAttribute('href')) sum.href = v.url;
    root.querySelectorAll('[data-ppgr-write]').forEach(function (a) {
      if (v.write && !a.getAttribute('href')) a.href = v.write;
    });

    this.items = this.pick(v);
    if (!this.items.length) {
      this.track.hidden = true;
      return;
    }
    this.url = v.url;
    var frag = document.createDocumentFragment();
    var self = this;
    this.items.forEach(function (r, k) { frag.appendChild(self.card(r, k)); });
    /* "See all … on Google" at the end of the row. */
    var allUrl = this.d.allUrl || v.url;
    if (this.d.all && allUrl) {
      var li = el('li', 'ppgr__card ppgr__card--all');
      var a = el('a', 'ppgr__all');
      a.href = allUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      a.insertAdjacentHTML('beforeend', G);
      a.appendChild(el('span', '', String(this.d.all).replace('[n]', v.n || '')));
      var go = el('span', 'ppgr__all-go');
      go.setAttribute('aria-hidden', 'true');
      go.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" focusable="false"><path d="M6 3.5 10.5 8 6 12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      a.appendChild(go);
      li.appendChild(a);
      frag.appendChild(li);
    }
    this.track.textContent = '';
    this.track.appendChild(frag);
    if (this.d.layout === 'wall') this.wall();
    /* "Read more" only where the text is cut short. */
    requestAnimationFrame(function () {
      self.track.querySelectorAll('.ppgr__card').forEach(function (c) {
        var t = c.querySelector('.ppgr__text');
        var more = c.querySelector('.ppgr__more');
        if (t && more) more.hidden = t.scrollHeight <= t.clientHeight + 2;
      });
      self.update();
    });
    this.wire();
  };

  /* Wall: the first N reviews, then "Show more" adds N at a time (the "See all" card stays last). */
  Section.prototype.wall = function () {
    var btn = this.root.querySelector('[data-ppgr-showmore]');
    var per = Number(this.d.wallStart) || 9;
    var cards = Array.prototype.slice.call(this.track.querySelectorAll('.ppgr__card:not(.ppgr__card--all)'));
    var shown = Math.min(per, cards.length);
    var show = function () {
      cards.forEach(function (c, k) { c.hidden = k >= shown; });
      if (btn) btn.hidden = shown >= cards.length;
    };
    show();
    if (btn && !btn.__ppgr) {
      btn.__ppgr = true;
      btn.addEventListener('click', function () {
        var from = shown;
        shown = Math.min(shown + per, cards.length);
        show();
        /* keep keyboard users in place: focus the first new review's first control, or the button's place */
        var next = cards[from] && cards[from].querySelector('a, button');
        if (next) next.focus({ preventScroll: true });
      });
    }
  };

  Section.prototype.card = function (r, k) {
    var li = el('li', 'ppgr__card');
    li.appendChild(top(r, this.url));
    li.appendChild(stars(r.s, this.d.starsTpl));
    li.appendChild(el('p', 'ppgr__text', r.x));
    var foot = el('div', 'ppgr__foot');
    var more = el('button', 'ppgr__more', this.d.more || 'Read more');
    more.type = 'button';
    more.hidden = true;
    more.setAttribute('data-k', k);
    foot.appendChild(more);
    if (r.i.length) {
      var pics = el('div', 'ppgr__pics');
      var shown = r.i.slice(0, 3);
      var alt = String(this.d.photosAlt || '').replace('[name]', r.a);
      shown.forEach(function (u, n) {
        var b = el('button', 'ppgr__pic');
        b.type = 'button';
        b.setAttribute('data-k', k);
        b.setAttribute('data-p', n);
        /* the "+2" shown on the last photo is part of its name, so a spoken "tap plus 2" finds it */
        var more = n === 2 && r.i.length > 3 ? '+' + (r.i.length - 3) : '';
        b.setAttribute('aria-label', more ? alt + ', ' + more : alt);
        var img = el('img');
        img.src = sized(u, 'w96-h96');
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.referrerPolicy = 'no-referrer';
        b.appendChild(img);
        if (more) b.appendChild(el('em', '', more));
        pics.appendChild(b);
      });
      foot.appendChild(pics);
    }
    li.appendChild(foot);
    return li;
  };

  /* ---------- the whole review ---------- */
  Section.prototype.open = function (k, p) {
    var r = this.items[k];
    if (!r || !this.dlg) return;
    var self = this;
    var body = this.body;
    body.textContent = '';
    body.appendChild(top(r, this.url));
    body.appendChild(stars(r.s, this.d.starsTpl));
    if (r.i.length) {
      var viewer = el('div', 'ppgr__viewer');
      var img = el('img');
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      var count = el('span', 'ppgr__viewer-count');
      var at = Math.min(p || 0, r.i.length - 1);
      var alt = String(this.d.photosAlt || '').replace('[name]', r.a);
      var show = function (n) {
        at = (n + r.i.length) % r.i.length;
        img.src = sized(r.i[at], 'w1200');
        img.alt = alt;
        count.textContent = String(self.d.photoTpl).replace('[n]', at + 1).replace('[total]', r.i.length);
      };
      viewer.appendChild(img);
      if (r.i.length > 1) {
        [['prev', -1, 'M10 3.5 5.5 8l4.5 4.5'], ['next', 1, 'M6 3.5 10.5 8 6 12.5']].forEach(function (d) {
          var b = el('button', 'ppgr__viewer-nav ppgr__viewer-nav--' + d[0]);
          b.type = 'button';
          b.setAttribute('aria-label', self.root.querySelector('[data-ppgr-' + d[0] + ']') ? self.root.querySelector('[data-ppgr-' + d[0] + ']').getAttribute('aria-label') : d[0]);
          b.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true" focusable="false"><path d="' + d[2] + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          b.addEventListener('click', function () { show(at + d[1]); });
          viewer.appendChild(b);
        });
        viewer.appendChild(count);
      }
      show(at);
      body.appendChild(viewer);
    }
    if (r.x) body.appendChild(el('p', 'ppgr__text', r.x));
    this.stopAuto();
    document.body.classList.add('ppgr-open');
    if (typeof this.dlg.showModal === 'function') this.dlg.showModal();
    else this.dlg.setAttribute('open', '');
  };

  Section.prototype.close = function () {
    if (this.dlg.open && typeof this.dlg.close === 'function') this.dlg.close();
    else this.dlg.removeAttribute('open');
  };

  /* ---------- the row ---------- */
  Section.prototype.step = function () {
    var card = this.track.querySelector('.ppgr__card');
    return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
  };

  Section.prototype.update = function () {
    this.ticking = false;
    var t = this.track;
    var max = t.scrollWidth - t.clientWidth;
    var atStart = t.scrollLeft <= 1;
    var atEnd = t.scrollLeft >= max - 1;
    this.rail.classList.toggle('is-start', atStart);
    this.rail.classList.toggle('is-end', atEnd || max <= 1);
    if (this.arrows) {
      this.arrows.hidden = max <= 1;
      this.arrows.querySelector('[data-ppgr-prev]').disabled = atStart;
      this.arrows.querySelector('[data-ppgr-next]').disabled = atEnd;
    }
  };

  /* page: the arrows move by the reviews in view (2 Oct 2026); autoplay moves one */
  Section.prototype.go = function (dir, page) {
    var by = this.step();
    if (page && window.ppPageStep) by = window.ppPageStep(this.track, this.track.querySelector('.ppgr__card'), parseFloat(getComputedStyle(this.track).columnGap || 0));
    this.track.scrollBy({ left: dir * by, behavior: calm.matches ? 'auto' : 'smooth' });
  };

  Section.prototype.stopAuto = function () {
    this.userMoved = true;
    clearInterval(this.timer);
    this.timer = 0;
  };

  Section.prototype.wire = function () {
    if (this.wired) return;
    this.wired = true;
    var self = this;
    var t = this.track;

    if (this.arrows) {
      this.arrows.querySelector('[data-ppgr-prev]').addEventListener('click', function () { self.stopAuto(); self.go(-1, true); });
      this.arrows.querySelector('[data-ppgr-next]').addEventListener('click', function () { self.stopAuto(); self.go(1, true); });
    }
    t.addEventListener('scroll', function () {
      if (!self.ticking) { self.ticking = true; requestAnimationFrame(function () { self.update(); }); }
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.update(); }).observe(t);

    /* Read more / photo → the whole review. */
    t.addEventListener('click', function (e) {
      if (self.dragged) { e.preventDefault(); e.stopPropagation(); self.dragged = false; return; }
      var b = e.target.closest('.ppgr__more, .ppgr__pic');
      if (!b) return;
      self.open(Number(b.getAttribute('data-k')), Number(b.getAttribute('data-p') || 0));
    }, true);

    if (this.dlg) {
      this.dlg.querySelector('[data-ppgr-close]').addEventListener('click', function () { self.close(); });
      /* A click on the dimmed page (the dialog's own box, outside its content) closes it. */
      this.dlg.addEventListener('click', function (e) { if (e.target === self.dlg) self.close(); });
      this.dlg.addEventListener('close', function () {
        document.body.classList.remove('ppgr-open');
        self.body.textContent = '';
      });
    }

    /* Mouse drag; touch keeps the browser's own swipe. */
    var startX = 0, startLeft = 0, down = false, moved = false;
    var glide = window.ppGlideTrack ? window.ppGlideTrack() : null;
    t.addEventListener('pointerdown', function (e) {
      self.stopAuto();
      if (e.pointerType !== 'mouse' || e.button !== 0 || self.d.layout === 'wall') return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = t.scrollLeft;
      if (glide) { glide.reset(); glide.add(e.clientX); }
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; t.classList.add('is-dragging'); }
      if (moved) t.scrollLeft = startLeft - dx;
      if (glide) glide.add(e.clientX);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        /* a fast drag glides on, so one drag can reach the end */
        if (glide && window.ppGlide) window.ppGlide(t, glide.speed());
        self.dragged = true;
        requestAnimationFrame(function () { t.classList.remove('is-dragging'); });
        setTimeout(function () { self.dragged = false; }, 50);
      }
    });
    t.addEventListener('focusin', function () { self.stopAuto(); });

    /* Autoplay: one card every 5 s while in view and not hovered. */
    if (this.d.auto === 'true' && !calm.matches && this.d.layout !== 'wall') {
      var inView = false, hover = false;
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }, { threshold: 0.4 }).observe(t);
      t.addEventListener('mouseenter', function () { hover = true; });
      t.addEventListener('mouseleave', function () { hover = false; });
      this.timer = setInterval(function () {
        if (self.userMoved || !inView || hover || document.hidden || (self.dlg && self.dlg.open)) return;
        var max = t.scrollWidth - t.clientWidth;
        if (t.scrollLeft >= max - 2) t.scrollTo({ left: 0, behavior: 'smooth' });
        else self.go(1);
      }, 5000);
    }
  };

  function init() {
    document.querySelectorAll('[data-ppgr]').forEach(function (root) {
      if (!root.__ppgr) root.__ppgr = new Section(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  /* a page swapped in by the bottom bar (assets/pp-app-nav.js) */
  document.addEventListener('pp:section:load', init);
})();
